import { useThrottleFn } from "@vueuse/core";
import { computed, ref, watch, type Ref } from "vue";
import { useMap } from "./google-map";

type MarkerRef = Ref<google.maps.Marker | null>;
type PositionRef = Ref<google.maps.LatLng | google.maps.LatLngLiteral | null>;

export function useReactiveMarkerPosition(marker: MarkerRef) {
	const map = useMap();

	const markerPosition: PositionRef = ref(null);

	const updateMarkerPosition = useThrottleFn(async () => {
		requestAnimationFrame(() => {
			markerPosition.value = marker.value?.getPosition() ?? null;
		});
	}, 100);

	watch([map, marker], (_, __, onCleanup) => {
		if (map.value == null || marker.value == null) {
			return;
		}

		updateMarkerPosition();

		const listeners: google.maps.MapsEventListener[] = [];

		listeners.push(marker.value.addListener("drag", updateMarkerPosition));

		onCleanup(() => {
			for (const listener of listeners) {
				listener.remove();
			}
		});
	});

	return computed({
		get() {
			return markerPosition.value;
		},
		set(pos) {
			markerPosition.value = pos;

			if (marker.value != null) {
				marker.value.setPosition(pos);
			}
		},
	});
}
